import React, { useState } from "react";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { NavLink, useLocation } from "react-router-dom";
import "./sidenav/sidenav.css";
import { useAuth } from "../auth/authContext";

const SideNav = () => {
  const { SideNav, navData } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(true);
  const [openChildId, setOpenChildId] = useState(() => {
    const activeParent = navData.find((item) =>
      item.children?.some((child) => child.link === location.pathname)
    );
    return activeParent ? activeParent.id : null;
  });

  const toggleOpen = () => {
    setOpen(!open);
    SideNav(!open);
  };

  const toggleChildOpen = (id) => {
    setOpenChildId((current) => (current === id ? null : id));
  };

  return (
    <div className={open ? "sidenav" : "sidenavClosed"}>
      <div className="text-right">
        <button className="menuBtn" onClick={toggleOpen}>
          {open ? <ArrowCircleLeftIcon /> : <ArrowCircleRightIcon />}
        </button>
      </div>

      {/* Render Navigation Items */}
      {navData.map((item) => {
        const hasChildren = Array.isArray(item.children) && item.children.length > 0;
        const isChildOpen = openChildId === item.id;

        return (
          <div key={item.id}>
            <NavLink
              className={({ isActive }) => `sideitem ${isActive ? "active" : ""}`}
              to={item.link}
              onClick={hasChildren ? () => toggleChildOpen(item.id) : undefined}
            >
              <div className="sideItemchild">
                <div className="navItemIconText">
                  {item.icon}
                  <span className={open ? "linkText" : "linkTextClosed"}>
                    {item.text}
                  </span>
                </div>
                {hasChildren && (
                  <div className="arrowContainer">
                    {isChildOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                  </div>
                )}
              </div>
            </NavLink>

            {/* Child Menu Items */}
            {hasChildren && (
              <div className={isChildOpen ? "childMenuOpen" : "childMenu"}>
                {item.children.map((child) => (
                  <NavLink
                    key={child.id}
                    className={({ isActive }) => `childMenuSideNav ${isActive ? "active" : ""}`}
                    to={child.link}
                  >
                    {child.icon}
                    <span className={open ? "linkText" : "linkTextClosed"}>
                      {child.text}
                    </span>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SideNav;
